<template>
  <section class="lexbox-redirect-container">
    <HeaderComponent />
    <section class="lexbox-redirect-section"></section>
  </section>
</template>

<script lang="ts" setup>
import { onMounted } from 'vue'
import store from '@/store/store'
import { ModuleNamespaces } from '@/store/types/storeGlobalTypes'
import HeaderComponent from '@/components/Header/HeaderComponent.vue'

async function redirectToService() {
  window.location.replace(process.env.VUE_APP_SSO_UNPAID)
}

onMounted(() => {
  store.commit(`${ModuleNamespaces.SPINNER}/SHOW_SPINNER`, true)
  redirectToService()
})
</script>

<style lang="scss" scoped>
.lexbox-redirect {
  &-container {
    @include external-view-layout;
  }

  &-section {
    @include flex;
    flex-direction: column;
    margin: 30px;
  }

  &-card {
    @include flex($flex-direction: column, $justify-content: flex-start);
    @include borders;
    width: 450px;
    padding-top: 50px;
  }
}
</style>
